module.exports = __webpack_public_path__ + "static/media/20-1.ed1c5b4f.mp3";